import {connect} from 'react-redux'
import {translateText} from 'actions/language'
import {getTargetLanguage, getLanguageMap} from 'selectors/language'
import Translator from './translater'
import {getUser} from 'selectors/auth'

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    targetLanguage: getTargetLanguage(state),
    languageMap: getLanguageMap(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onTranslate: (text) => dispatch(translateText(text)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Translator)
